import { render } from "./Action.vue?vue&type=template&id=1053a69d&scoped=true"
import script from "./Action.vue?vue&type=script&lang=js"
export * from "./Action.vue?vue&type=script&lang=js"

import "./Action.vue?vue&type=style&index=0&id=1053a69d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1053a69d"]])

export default __exports__